import React from 'react';
import PropTypes from 'prop-types';
import * as colors from '../lib/colors';
import {
  Container,
  Hero,
  ThreeStars,
  SurveyCompletedLink,
  SurveyCompletedText,
} from './layoutHelpers';
import { FaBluesky, FaFacebook, FaEnvelope, FaTwitter } from "react-icons/fa6";

const LandingPage = (props) => {
  return (
    <Container>
      <Hero>
        {props.bannerContent}
        <ThreeStars />
        <ul style={{ listStyleType: 'none' }}>
          <li style={{ padding: '25px 0' }}>
            <SurveyCompletedLink href="/results/">
              <span>Survey Results</span>
            </SurveyCompletedLink>
          </li>
          {(props.instructionalContent)
            ? <li style={{ padding: '25px 0' }}>
                {props.instructionalContent}
              </li>
            : null
          }
          <li style={{ padding: '25px 0' }}>
            <SurveyCompletedText>
              Spread the word! Give more people a way to make their voices
              heard:
            </SurveyCompletedText>
            <div style={{ marginTop: '20px' }}>
              <a
                href="mailto:?subject=Civiqs surveys&body=Hi,%0D%0A%0D%0AJoin me on the Civiqs research panel! Civiqs makes your views heard. You receive periodic emails when a new poll is ready. Most surveys take less than a minute. That’s it! https://civiqs.com/join-in%0D%0A%0D%0A Check out the results of Civiqs surveys with new results updated every day: https://civiqs.com/results%0D%0A%0D%0AThanks!"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                  }}
                >
                  <FaEnvelope size={30} color={colors.ULTRALIGHT_GREY} />
                </span>
              </a>
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=civiqs.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                  }}
                >
                  <FaFacebook size={30} color={colors.ULTRALIGHT_GREY} />
                </span>
              </a>
              <a
                href="https://twitter.com/intent/tweet?text=Join%20me%20on%20the%20%40Civiqs%20research%20panel!%20Civiqs%20makes%20your%20views%20heard.%20You%20receive%20periodic%20emails%20when%20a%20new%20poll%20is%20ready.%20Most%20surveys%20take%20less%20than%20a%20minute.%20That%E2%80%99s%20it!%20https%3A%2F%2Fciviqs.com%2Fjoin-in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                  }}
                >
                  <FaTwitter size={30} color={colors.ULTRALIGHT_GREY} />
                </span>
              </a>
              <a
                href="https://bsky.app/intent/compose?text=Join%20me%20on%20the%20%40Civiqs%20research%20panel!%20Civiqs%20makes%20your%20views%20heard.%20You%20receive%20periodic%20emails%20when%20a%20new%20poll%20is%20ready.%20Most%20surveys%20take%20less%20than%20a%20minute.%20That%E2%80%99s%20it!%20https%3A%2F%2Fciviqs.com%2Fjoin-in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                  }}
                >
                  <FaBluesky size={30} color={colors.ULTRALIGHT_GREY} />
                </span>
              </a>
            </div>
          </li>
        </ul>
      </Hero>
    </Container>
  );
};

LandingPage.propTypes = {
  bannerContent: PropTypes.node,
  instructionalContent: PropTypes.node,
};

LandingPage.defaultProps = {
  bannerContent: null,
  instructionalContent: null
}

export default LandingPage;
export { LandingPage };
